import { render, staticRenderFns } from "./arguments-config.vue?vue&type=template&id=1ec5cfce&"
import script from "./arguments-config.component.ts?vue&type=script&lang=ts&"
export * from "./arguments-config.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports